export const erc20TokenABI = [
  'function approve(address _spender, uint256 _value) public returns (bool success)',
  'function balanceOf(address) view returns (uint)',
  'function decimals() public view returns (uint8)',
  'function symbol() public view returns (string)',
  'function allowance(address owner, address spender) view returns (uint256)',
];
